import React, { PureComponent, createRef } from 'react';
import { findDOMNode } from 'react-dom';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Popup } from 'zarm';
import { events, eventEmitter } from '@iyunbao/utils';
import { getSafeIphoneX } from '../utils/tools';
import LockScroll from '../lockScroll';

export interface PopupBottomProps {
  onClose: () => void;
  onScroll?: (data?: any) => void;
  onInitScroll?: (data?: any) => void;
  title?: any;
  footer: any;
  isMaskClick: boolean;
  className?: string;
  isShowCloseButton?: boolean;
  animationDuration?: number;
}

export interface PopupBottomState {
  visible: boolean;
  style?: any;
}

let timer: number | null = null;

class PopupBottom extends PureComponent<PopupBottomProps, PopupBottomState> {
  static defaultProps = {
    isMaskClick: true,
    isShowCloseButton: true,
    visible: false,
    className: '',
    onClose: () => { },
    onScroll: () => { },
    onInitScroll: () => { },
    animationDuration: 200,
    title: '',
    footer: '',
  };

  static propTypes = {
    isMaskClick: PropTypes.bool,
    visible: PropTypes.bool,
    isShowCloseButton: PropTypes.bool,
    className: PropTypes.string,
    onClose: PropTypes.func,
    onScroll: PropTypes.func,
    onInitScroll: PropTypes.func,
    animationDuration: PropTypes.number,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]),
    footer: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]),
  };

  // 滚动条
  bodyRef: any = createRef();

  // 绑定一次
  firstBind: boolean = false;

  constructor (props) {
    super(props);
    this.state = {
      visible: (props.visible || false),
      style: this.getViewHeight(),
    };
  }

  componentDidMount() {
    this.onScroll();

    eventEmitter.addListener('updateSesize', () => {
      timer && clearTimeout(timer);
      timer = setTimeout(() => {
        this.setState({
          style: this.getViewHeight(),
        });
      }, 300);
    });
  }
  
  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    const { visible } = this.state;

    if (visible !== nextProps.visible) {
      this.setState({ visible: nextProps.visible });
    }
  }

  componentDidUpdate() {
    if (!this.firstBind) {
      this.onScroll();
    }
  }

  onScroll = () => {
    const { onScroll, onInitScroll } = this.props;

    if (onScroll && this.bodyRef && this.bodyRef.current) {
      // eslint-disable-next-line react/no-find-dom-node
      const body: any = findDOMNode(this.bodyRef.current);

      this.firstBind = true;

      // 初始化滚动
      onInitScroll && onInitScroll(body);

      events.on(body, 'scroll', () => {
        onScroll(body);
      });
    }
  };

  onClose = () => {
    this.setState({ visible: false });
    this.props.onClose();
  };

  // 获取屏幕高度
  getViewHeight = () => {
    // server side
    if (typeof window === 'undefined') {
      return {
        maxHeight: 0,
      };
    }

    const spaceHeight = ((window.innerWidth || document.documentElement.clientWidth) > 640 ? 140 : 100);
    let height = (window.innerHeight || document.documentElement.clientHeight) * 0.95 - spaceHeight;
    const notchHeight = getSafeIphoneX();

    // 兼容刘海屏
    if (notchHeight) {
      height -= notchHeight;
    }

    return {
      maxHeight: height,
    };
  };

  renderHeader() {
    const { title, isShowCloseButton } = this.props;

    if (!title) {
      return null;
    }

    return (
      <div className="popup-header">
        <div className="title">{title}</div>
        {
          isShowCloseButton
          && <div className="button-clone" onClick={() => this.onClose()} />
        }
      </div>
    );
  }

  renderFooter() {
    const { footer } = this.props;

    if (!footer) {
      return null;
    }

    return (
      <div className="popup-footer">
        {footer}
      </div>
    );
  }

  render() {
    const { visible, style } = this.state;
    const { children, isMaskClick, className, animationDuration } = this.props;

    return (
      <LockScroll>
        <Popup
          visible={visible}
          direction="bottom"
          className={classnames('crm-popup-bottom', className)}
          onMaskClick={() => (isMaskClick && this.onClose())}
          afterClose={() => this.onClose()}
          animationDuration={animationDuration}
        >
          {this.renderHeader()}
          <div
            className="popup-body"
            style={style}
            ref={this.bodyRef}
          >
            {children}
          </div>
          {this.renderFooter()}
        </Popup>
      </LockScroll>
    );
  }
}

export default PopupBottom;
